import { applicationActionTypes } from '@constants/actionTypes';

export function removeFavicon() {
  const oldLink = document.getElementById('page-icon');
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
}

export function setFaviconSVG(svgString) {
  removeFavicon();

  const blob = new Blob([svgString], { type: 'image/svg+xml' });
  const svgURL = URL.createObjectURL(blob);

  // Create a new link element
  const link = document.createElement('link');
  link.rel = 'icon';
  link.type = 'image/svg+xml';
  link.href = svgURL;

  // Append the link element to the head of the document
  document.head.appendChild(link);
}

export function smoothScrollToAnchor(id, yOffset = 0) {
  const element = document.getElementById(id);
  if (element) {
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  } else {
    console.error('element not found');
  }
}

export function showErrorBanner(message, config, dispatch) {
  dispatch({
    type: applicationActionTypes.showErrorBanner,
    payload: { message, config },
  });
}

export function showSuccessBanner(message, config, dispatch) {
  dispatch({
    type: applicationActionTypes.showSuccessBanner,
    payload: { message, config },
  });
}
